// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from '@/plugins/vuetify'
import VueAnalytics from 'vue-analytics'
import filters from './filters'
import Chart from './components/Chart.vue'
import ScrollButtons from './components/ScrollButtons.vue'
import './styles/styles.scss'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
	dsn: "https://fdad6673d5c94d789c6becd248b5a161@o483106.ingest.sentry.io/5538662",
	integrations: [
		new VueIntegration({
			Vue,
			tracing: true,
		}),
		new Integrations.BrowserTracing(),
	],

	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1.0,
});

// import { StartupService } from 'webview-bridge-web'

Vue.config.productionTip = false

// Google Analytics
Vue.use(VueAnalytics, {
	id: 'UA-163540486-1'
})

Vue.use(filters)
new Vue({
	render: h => h(App),
	vuetify,
	router,
	store,
	components: { App, Chart, ScrollButtons }
}).$mount('#app')
